import React, { useEffect } from 'react';

import { SearchIcon } from '../Icons';

import './NoSearchResults.scss';

// TEALIUM
import initTealiumTracker from 'tealium-tracker';
let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

interface INoSearchResultsProps {
  searchTerm: string;
  analytics: any;
}
const NoSearchResults = ({ searchTerm, analytics }: INoSearchResultsProps) => {
  // Analytics
  useEffect(() => {
    // Quantum
    analytics.track('searched', {
      msgTriggeredBy: 'user',
      searchElem: 0,
      searchId: searchTerm,
      searchType: 'keyword',
      searchResultsMs: 500,
      searchText: searchTerm,
      searchResults: null,
    });

    // Tealium
    tealiumTrackEvent({
      searchKeyword: searchTerm,
      'qp.q': searchTerm,
      section: 'Search',
      pagename: 'Search Page',
      pagetype: 'Search Results',
      numResults: 0,
    });
  }, [analytics, searchTerm]);

  return (
    <section className="no-search-results">
      <h2 className="no-search-results__count">
        No results found for {`"${searchTerm}"`}.
      </h2>

      <div className="no-search-results__content">
        <SearchIcon className="no-search-results__icon" />
        <h3 className="no-search-results__title">No Results Were Found</h3>
        <p className="no-search-results__subtitle">
          Please check your spelling or try another search term.
        </p>
      </div>
    </section>
  );
};

export default NoSearchResults;
